"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddRemoveDialog = exports.AddRemoveDialogConfig = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const $ = require("jquery");
/**
* Configuration for the AddRemoveDialog
*/
class AddRemoveDialogConfig {
}
exports.AddRemoveDialogConfig = AddRemoveDialogConfig;
/**
* Class that presents two lists (active and inactive) and provides buttons to move items from one list to the other
*/
class AddRemoveDialog {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    /**
    * Creates the dialog, but does not show it yet.
    */
    constructor(config) {
        let cfg = new AddRemoveDialogConfig();
        cfg.dialogResult = (cancel, activeItemIds, inactiveItemIds) => { };
        cfg.getAllItems = (callback) => { callback([]); };
        cfg.getActiveItemIds = (callback) => { callback([]); };
        cfg.itemToId = (item) => undefined;
        cfg.compare = (t1, t2) => -1;
        cfg.windowTitle = "syneris";
        cfg.width = 700;
        cfg.height = 384;
        this.m_config = $.extend(true, cfg, config);
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    /**
    * Shows the dialog
    */
    show() {
        let that = this;
        // Create new window based on the configuration
        let windowData = Utilities_1.synUtil.popupWindow({
            title: that.m_config.windowTitle,
            width: that.m_config.width,
            height: that.m_config.height,
            resizable: true,
            modal: true,
            actions: ["Maximize", "Close"],
            synDesktopAware: true
        });
        require.ensure(["./AddRemoveDialog.tmpl.less"], function (require) {
            require("./AddRemoveDialog.tmpl.less");
            let addRemoveDlgMarkup = require("./AddRemoveDialog.tmpl.html");
            let template = kendo.template(addRemoveDlgMarkup);
            windowData.windowDiv.html(template({}));
            that.m_$windowDiv = windowData.windowDiv;
            let $activeList = windowData.windowDiv.find("div.enabledListView");
            let $inactiveList = windowData.windowDiv.find("div.disabledListView");
            let $okButton = windowData.windowDiv.find("button.okButton").text(Utilities_1.synUtil.Strings.getValue("menuok"));
            let $cancelButton = windowData.windowDiv.find("button.cancelButton").text(Utilities_1.synUtil.Strings.getValue("menucancel"));
            $okButton.add($cancelButton).on("click", function () {
                let cancel = $(this).hasClass("cancelButton");
                let activeIds = $.map($activeList.data("kendoListView").dataSource.data(), (item) => {
                    return that.m_config.itemToId(item);
                });
                let inactiveIds = $.map($inactiveList.data("kendoListView").dataSource.data(), (item) => {
                    return that.m_config.itemToId(item);
                });
                $("#" + windowData.windowID).data("kendoWindow").close();
                that.m_config.dialogResult(cancel, activeIds, inactiveIds);
            });
            // Initially disable, until data is loaded
            Utilities_1.synUtil.toggleEnabledState($okButton, false);
            // Listview headers
            windowData.windowDiv.find("div.enabledHeader")
                .text(Utilities_1.synUtil.Strings.getValue("custitemsvisibleitems"));
            windowData.windowDiv.find("div.disabledHeader")
                .text(Utilities_1.synUtil.Strings.getValue("custitemsinvisibleitems"));
            // Setup list views----------------------------------------------------
            let activeItems = [];
            let inactiveItems = [];
            windowData.beginInit();
            // Fetch all items. After that, fetch ids of active items. With these two informations,
            // each item can be added to one of the two lists.
            that.m_config.getAllItems(allItems => {
                that.m_config.getActiveItemIds(activeItemIds => {
                    windowData.endInit();
                    let $addButton = windowData.windowDiv.find("button.addButton");
                    let $removeButton = windowData.windowDiv.find("button.removeButton");
                    // Initially disable both buttons
                    Utilities_1.synUtil.toggleEnabledState($addButton, false);
                    Utilities_1.synUtil.toggleEnabledState($removeButton, false);
                    if (typeof activeItemIds === "undefined")
                        $.each(allItems, (idx, item) => { activeItems.push(item); });
                    else {
                        let mapActive = {};
                        $.each(activeItemIds, (idx, id) => { mapActive[id] = true; });
                        $.each(allItems, (idx, item) => {
                            if (mapActive[that.m_config.itemToId(item)])
                                activeItems.push(item);
                            else
                                inactiveItems.push(item);
                        });
                    }
                    activeItems.sort(that.m_config.compare);
                    inactiveItems.sort(that.m_config.compare);
                    $activeList.kendoListView({
                        change: () => {
                            if ($activeList.data("kendoListView").select().length) {
                                $inactiveList.data("kendoListView").clearSelection();
                                Utilities_1.synUtil.toggleEnabledState($removeButton, true);
                                Utilities_1.synUtil.toggleEnabledState($addButton, false);
                            }
                        },
                        dataBound: (e) => {
                            $(e.sender.items())
                                .addClass("addRemoveItem")
                                .on("dblclick", (evt) => {
                                that.move($(evt.target), false);
                            });
                        },
                        selectable: "multiple",
                        template: kendo.template(that.m_config.itemTemplate || AddRemoveDialog.Default_Template),
                        dataSource: { data: activeItems },
                    });
                    $inactiveList.kendoListView({
                        change: () => {
                            if ($inactiveList.data("kendoListView").select().length) {
                                $activeList.data("kendoListView").clearSelection();
                                Utilities_1.synUtil.toggleEnabledState($addButton, true);
                                Utilities_1.synUtil.toggleEnabledState($removeButton, false);
                            }
                        },
                        dataBound: (e) => {
                            $(e.sender.items())
                                .addClass("addRemoveItem")
                                .on("dblclick", (evt) => {
                                that.move($(evt.target), true);
                            });
                        },
                        selectable: "multiple",
                        template: kendo.template(that.m_config.itemTemplate || AddRemoveDialog.Default_Template),
                        dataSource: { data: inactiveItems }
                    });
                    $addButton.add($removeButton)
                        .on("click", function () {
                        that.move(undefined, $(this).hasClass("addButton"));
                    });
                    Utilities_1.synUtil.toggleEnabledState($okButton, true);
                });
            });
        });
    }
    move($items, add) {
        let $activeList = this.m_$windowDiv.find("div.enabledListView");
        let $inactiveList = this.m_$windowDiv.find("div.disabledListView");
        let $source = add ? $inactiveList : $activeList;
        let $target = add ? $activeList : $inactiveList;
        let lvSource = $source.data("kendoListView");
        let lvTarget = $target.data("kendoListView");
        let $selection = $items == undefined ? lvSource.select() : $items;
        let selection = $.map($selection, (item) => lvSource.dataItem(item));
        let selectionIdsMap = {};
        for (let i = 0; i < selection.length; i++)
            selectionIdsMap[selection[i].get("id")] = true;
        let newDataTarget = [];
        let oldDataTarget = lvTarget.dataSource.data();
        for (let i = 0; i < oldDataTarget.length; i++)
            newDataTarget.push(oldDataTarget[i]);
        $.each(selection, (idx, selItem) => {
            lvSource.dataSource.remove(selItem);
            newDataTarget.push(selItem);
        });
        newDataTarget.sort(this.m_config.compare);
        lvTarget.dataSource.data(newDataTarget);
        lvTarget.element.focus();
        let $targetSelection = $();
        for (let i = 0; i < newDataTarget.length; ++i)
            if (selectionIdsMap[newDataTarget[i].id])
                $targetSelection = $targetSelection.add($(lvTarget.items()[i]));
        lvTarget.select($targetSelection);
    }
}
exports.AddRemoveDialog = AddRemoveDialog;
AddRemoveDialog.Default_Template = "<div class='addRemoveItem'>#:data.toString()#</div>";
AddRemoveDialog.Instance_Template = "<div class='addRemoveItem'>#:name.value#</div>";
